import { AnyObject } from 'antd/es/_util/type'

export const extractFormFieldIds = (data: AnyObject) => {
  return Object.keys(data).reduce((result, key) => {
    if (Array.isArray(data[key])) {
      result[key] = data[key]
        .map((item: AnyObject) =>
          item !== null && typeof item === 'object' ? item.id : item
        )
        .filter((v: unknown) => v !== undefined && v !== null)
    } else if (data[key]?.id) {
      result[key] = data[key].id
    }
    return result
  }, {} as AnyObject)
}
